import { render, staticRenderFns } from "./LenderTest.vue?vue&type=template&id=2852ea00&scoped=true&"
import script from "./LenderTest.vue?vue&type=script&lang=js&"
export * from "./LenderTest.vue?vue&type=script&lang=js&"
import style0 from "./LenderTest.vue?vue&type=style&index=0&id=2852ea00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852ea00",
  null
  
)

export default component.exports